/**
 * mtrStruct 樹狀 read — 非 CRUD 分頁列表。
 *
 * @see docs/API_IMSMGMT_MTR_STRUCT.md
 */
import request from '#/utils/request';
import { parseVer4TreeResponse } from '#/api/adapters/envelope';

export async function fetchMtrStructTree(params = { status: 'ACTIVE' }) {
  const { data: raw } = await request.get('/mtr-struct/tree', { params });
  return parseVer4TreeResponse(raw);
}
